import { StoredLink } from '../link/type/StoredLink';
import setInLocalStorage from './local/set';
import setCookie from './cookie/set';

type T = (link: StoredLink) => void;

const f: T = (link) => {
    setInLocalStorage('share-link', link);
    setCookie('share-link', link);
};

export default f;
